const state = () => ({
    overlay: false
});

const mutations = { 
    setOverlay(state, overlay) {
        state.overlay = overlay
    }
}

const getters = {
    overlay: (state) => state.overlay
}

const actions = {
    async setOverlayAction(context, overlay) {
        context.commit('setOverlay', overlay)
    }
}

export default {
    state, mutations, actions, getters
}